export default () => {
  const appBannerLayout = document.querySelector(".app-banner");

  const appBannerGlobal = () => {
    const headerFixed = () => {
      if (appBannerLayout) {
        const body = document.querySelector("body");
        var offsetTop = window.pageYOffset;
        var appBannerHeight = appBannerLayout.clientHeight;

        if(offsetTop < appBannerHeight) {
          body.classList.add("js-app-banner");
        } else {
          body.classList.remove("js-app-banner");
        }
      }
    };

    window.addEventListener("load", () => headerFixed());
    window.addEventListener("scroll", () => headerFixed());
  };

  if(appBannerLayout) {
    appBannerGlobal();
  }
}
